"use strict";

import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { onReady } from '../core/ready.js';

const HERO_VIDEO_LOOP_END = 3; // secondi per il loop in background

function initHeroBlock() {
    const heroBlocks = document.querySelectorAll('.block-hero');
    if (!heroBlocks.length) return;

    heroBlocks.forEach((videoBlock) => {
        const videoWrapper = videoBlock.querySelector('.block-video-wrapper');
        const playButton = videoBlock.querySelector('.block-video-play');
        const videoElement = videoBlock.querySelector('.block-video');

        if (!playButton || !videoElement) return;

        const useModal = videoWrapper.dataset.heroVideoModal === '1';
        const modalEl = useModal ? videoBlock.querySelector('.block-hero-video-modal') : null;
        const modalVideo = modalEl ? modalEl.querySelector('.block-hero-video-modal-video') : null;

        if (useModal && modalEl && modalVideo) {
            // Layout video-on-right / video-on-left: preview in loop 0–3 sec, click apre modale
            videoElement.muted = true;
            videoElement.playsInline = true;
            videoElement.loop = false;
            videoElement.setAttribute("muted", "");
            videoElement.setAttribute("playsinline", "");
            videoElement.dataset.videoAutoplay = "off";

            videoElement.addEventListener("timeupdate", function onTimeUpdate() {
                if (this.currentTime >= HERO_VIDEO_LOOP_END) {
                    this.currentTime = 0;
                    this.play().catch(() => {});
                }
            }, { passive: true });

            if ("IntersectionObserver" in window) {
                const teaserObserver = new IntersectionObserver((entries) => {
                    entries.forEach(({ target, isIntersecting }) => {
                        if (isIntersecting) {
                            target.play().catch(() => {});
                        } else {
                            target.pause();
                        }
                    });
                }, { threshold: 0.25 });
                teaserObserver.observe(videoElement);
            } else {
                videoElement.play().catch(() => {});
            }

            function openHeroVideoModal() {
                const Modal = window.bootstrap?.Modal;
                if (!Modal) return;
                const instance = Modal.getOrCreateInstance(modalEl);
                instance.show();
                modalEl.addEventListener('shown.bs.modal', function onShown() {
                    modalEl.removeEventListener('shown.bs.modal', onShown);
                    const videoWrap = modalEl.querySelector('.block-hero-video-modal-video-wrap');
                    function setModalAspectRatio() {
                        if (videoWrap && modalVideo.videoWidth && modalVideo.videoHeight) {
                            const ratio = modalVideo.videoWidth / modalVideo.videoHeight;
                            videoWrap.style.setProperty('--video-aspect', String(ratio));
                        }
                    }
                    if (modalVideo.readyState >= 1) {
                        setModalAspectRatio();
                    } else {
                        modalVideo.addEventListener('loadedmetadata', setModalAspectRatio, { once: true });
                    }
                    modalVideo.currentTime = 0;
                    modalVideo.play().catch(() => {});
                    document.body.classList.add('no-scroll');
                    const lenis = window.__lenis;
                    if (lenis && typeof lenis.stop === 'function') lenis.stop();
                    const backdrop = document.querySelector('.modal-backdrop');
                    if (backdrop) backdrop.style.zIndex = '99998';
                    modalEl.style.zIndex = '99999';
                }, { once: true });
            }

            playButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                openHeroVideoModal();
            });

            videoWrapper.addEventListener('click', (e) => {
                if (e.target === playButton || playButton.contains(e.target)) return;
                openHeroVideoModal();
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                modalVideo.pause();
                modalVideo.currentTime = 0;
                document.body.classList.remove('no-scroll');
                const lenis = window.__lenis;
                if (lenis && typeof lenis.start === 'function') lenis.start();
                modalEl.style.zIndex = '';
                const backdrop = document.querySelector('.modal-backdrop');
                if (backdrop) backdrop.style.zIndex = '';
            });
        } else {
            // Comportamento classico: play/pause inline
            playButton.addEventListener('click', () => {
                if (videoWrapper.classList.contains('playing')) {
                    videoElement.pause();
                    videoWrapper.classList.remove('playing');
                } else {
                    videoElement.play();
                    videoWrapper.classList.add('playing');
                }
            }, { once: false });

            videoWrapper.addEventListener('click', () => {
                if (videoWrapper.classList.contains('playing')) {
                    videoElement.pause();
                    videoWrapper.classList.remove('playing');
                } else {
                    videoElement.play();
                    videoWrapper.classList.add('playing');
                }
            }, { once: false });
        }
    });

    initHeroGallerySlider();
}

function initHeroGallerySlider() {
    const sliders = document.querySelectorAll('.block-hero.video-background-with-gallery .block-gallery-swiper');
    if (!sliders.length) return;

    sliders.forEach((sliderEl) => {
        if (sliderEl.dataset.swiperReady === '1') return;
        sliderEl.dataset.swiperReady = '1';

        new Swiper(sliderEl, {
            modules: [Autoplay],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 0
                }
            }
        });
    });
}

onReady(initHeroBlock);
